import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import PlantLibraryPage from './pages/PlantLibraryPage';
import AMCMaintenancePage from './pages/AMCMaintenancePage';
import TrainingProgramsPage from './pages/TrainingProgramsPage';
import PlantRentalPage from './pages/PlantRentalPage';
import FranchiseModelPage from './pages/FranchiseModelPage';
import PlantStorePage from './pages/PlantStorePage';
import PlantsCollectionPage from './pages/PlantsCollectionPage';
import ProductPage from './pages/ProductPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/plant-library" element={<PlantLibraryPage />} />
            <Route path="/services/amc-maintenance" element={<AMCMaintenancePage />} />
            <Route path="/services/training-programs" element={<TrainingProgramsPage />} />
            <Route path="/services/plant-rental" element={<PlantRentalPage />} />
            <Route path="/services/franchise-model" element={<FranchiseModelPage />} />
            <Route path="/services/plant-store" element={<PlantStorePage />} />
            <Route path="/plants" element={<PlantsCollectionPage />} />
            <Route path="/products" element={<ProductPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

